import { render, staticRenderFns } from "./SideBarToggleButton.vue?vue&type=template&id=64265ee2&scoped=true&"
import script from "./SideBarToggleButton.vue?vue&type=script&lang=js&"
export * from "./SideBarToggleButton.vue?vue&type=script&lang=js&"
import style0 from "./SideBarToggleButton.vue?vue&type=style&index=0&id=64265ee2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64265ee2",
  null
  
)

export default component.exports